import React from "react";

import { HeatShade } from "../can-consumption-metrics";

export interface RankingRow {
  key: string;
  name: string;
  value: number;
  formattedValue: string;
  shade: HeatShade | null;
}

interface VehicleRankingProps {
  rows: RankingRow[];
  /** Fleet median of the indicator, drawn as a vertical mark over the bars */
  median: number | null;
  unit: string;
  emptyText: string;
}

const SHADE_COLOR: { [key in HeatShade]: string } = {
  best: "var(--heat-best)",
  good: "var(--heat-good)",
  neutral: "var(--heat-neutral)",
  warning: "var(--heat-warning)",
  critical: "var(--heat-critical)"
};

/**
 * One bar per vehicle, ordered worst first. Only vehicles above the minimum number of travels get
 * here: with two travels any machine leads a consumption ranking.
 */
const VehicleRanking: React.FC<VehicleRankingProps> = ({ rows, median, unit, emptyText }) => {

  if (rows.length === 0) return <div className="panel-empty">{emptyText}</div>;

  const highest = Math.max(...rows.map((row) => row.value), 0) || 1;

  return (
    <div className="ranking">
      {rows.map((row) => (
        <div className="ranking-row" key={row.key} title={`${row.name}: ${row.formattedValue} ${unit}`}>
          <span className="ranking-name">{row.name}</span>
          <span className="ranking-track">
            <span
              className="ranking-fill"
              style={{
                width: `${Math.min(100, (row.value / highest) * 100)}%`,
                background: SHADE_COLOR[row.shade ?? "neutral"]
              }}
            />
            {median !== null && (
              <span className="ranking-median" style={{ left: `${Math.min(100, (median / highest) * 100)}%` }} />
            )}
          </span>
          <span className="ranking-value">{row.formattedValue}</span>
        </div>
      ))}
    </div>
  );
};

export default VehicleRanking;
